import {Badge} from "@/components/ui/badge.tsx";
import Field from "@/components/form/Field.tsx";
import {Textarea} from "@/components/ui/textarea.tsx";
import {Button} from "@/components/ui/button.tsx";
import {Bot} from "lucide-react";
import AttachmentCard from "@/components/editor/AttachmentCard.tsx";
import axios from "axios";
import {useContext} from "react";
import {FormContext} from "@/components/form/Form.tsx";
import {Company} from "@/types/Company";

export default function Cegertekelo({attachments, documentId, reloadAttachments, company}: {
    attachments: Attachment[],
    documentId?: string,
    reloadAttachments: () => void,
    company?: Company
}) {
    function getAttachment() {
        const attachmentStored = attachments.sort((a, b) => a.created_at > b.created_at ? -1 : 1).find(a => a.position == "ai")
        if (attachmentStored) {
            return attachmentStored;
        }
        return undefined;
    }

    const formctx = useContext(FormContext);

    function genAiReport(prompt: string) {
        axios.post("/api/ai-report", {
            document_id: documentId,
            prompt: prompt,
            company: company,
        }).then(() => {
            const interval = setInterval(() => {
                reloadAttachments();
                axios.get('/api/ai-report/' + documentId).then(res => {
                    const ai_report_pending = res.data?.ai_report_pending;
                    formctx.setValue("ai_report_pending", ai_report_pending);
                    const ai_report_progress = res.data?.ai_report_progress;
                    formctx.setValue("ai_report_progress", ai_report_progress);
                    if (ai_report_pending == false && ai_report_progress == 100) {
                        reloadAttachments();
                        clearInterval(interval);
                    }
                })
            }, 1000)
        })
    }

    return <>
        <div className={"flex justify-center mt-4"}>
            <div className={"relative text-4xl font-black text-aiblue"}>
                Cégértékelő
                <Badge className={"-top-4 -right-6 absolute h-6 w-6"} variant={"ai"}>AI</Badge>
            </div>
        </div>
        <Field name={'ai_cegert'}>
            {
                (field) =>
                    <><Textarea className={"bg-white grow"} value={field.value}
                                onBlur={field.onBlur}
                                onChange={(e) => field.onChange(e.target.value)}></Textarea>
                        <div className={"flex justify-center"}>
                            <Field name={"ai_report_pending"}>
                                {(pending) => <>
                                    <Button disabled={pending.value} onClick={() => {
                                        pending.onChange(true);
                                        genAiReport(field.value);
                                    } }
                                            variant={"ai"}><Bot/> Generálás</Button>
                                </>}
                            </Field>
                        </div>
                    </>
            }
        </Field>
        <div className={"flex justify-center"}>
            <div className={"w-1/3"}>
                <Field name={"ai_report_progress"}>
                    {(field) => <>{
                        getAttachment() && <AttachmentCard attachment={getAttachment()} progress={field.value}/>
                    }</>
                    }
                </Field>
            </div>
        </div>
    </>
}